import { get, set } from 'lodash';
import GetRecord from 'src/lib/api/GetRecord';
import POP_LEVEL from 'src/lib/api/Populations.json';
import { APIS, METHOD_POST } from 'src/lib/constants/apis';
import { ANTRAG_VERBUNDPARTNER, KMU_PATHS, RUS_PATH } from 'src/lib/constants/componentsPath';
import {
	ART_DES_ANTRAGS,
	KOSTENTRAEGER,
	TEMPLATES,
	TEMPLATES_AB,
	TEMPLATES_DEMINIMIS,
	TEMPLATES_GENEHMIGUNG,
	TEMPLATES_MA,
	TEMPLATES_MITTEILUNG_ZUWENDUNGSGEBER,
	TEMPLATES_SELBST_ERKLAERUNG,
	TEMPLATES_SELBST_ERKLAERUNG_RUS,
	TEMPLATES_STAMMDATENBLATT,
	TEMPLATES_VN,
	TEMPLATES_ZN,
} from 'src/lib/constants/constant';
import {
	STRAPI_URL,
	TEMPLATES_SERVICE_CLIENT_ID,
	TEMPLATES_SERVICE_PASSWORD,
	TEMPLATES_SERVICE_SERVER_ID,
	TEMPLATES_URL,
} from 'src/lib/constants/url';
import { enumT, removeDataKeys, removeNullDeep, transformValues } from 'src/utils/helper';
import { getAntragstellerName, getVerbundPartnerName, getVPAnzeigeName } from './application-helper-function/AppHelperfunctions';

// import Schemas
import AbschlussBerichtSchema from 'src/lib/paths/abschlussbericht_FULL_Paths.json';
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
import KostenpositionSchema from 'src/lib/paths/kostenposition_FULL_Paths.json';
import MittelabrufSchema from 'src/lib/paths/mittelabruf_FULL_Paths.json';
import VerwendungsnacheisSchema from 'src/lib/paths/verwendungsnachweis_FULL_Paths.json';
import ZwischenBerichtSchema from 'src/lib/paths/zwischenbericht_FULL_Paths.json';
import { getMittelabrufeFromProjektJahr } from 'src/utils/dashboardHelper';
const P = Schema.attributes;
const MA_P = MittelabrufSchema.attributes;
const VN_P = VerwendungsnacheisSchema.attributes;
const ZN_P = ZwischenBerichtSchema.attributes;
const AB_P = AbschlussBerichtSchema.attributes;
const KP_P = KostenpositionSchema.attributes;

export const DownloadAntragPDF = async (
	application: any,
	readOnly: boolean,
	saveApplication: (submit: boolean, app: any, changeLastEdited: boolean) => void,
	imagePaths?: any[],
) => {
	const ImagesPaths = imagePaths || [];
	const appId = get(application, 'id');
	const templateURL = TEMPLATES_URL + get(TEMPLATES, get(application, P.Allgemein_Antragsformular.path));
	let images = [];
	if (!readOnly) {
		await saveApplication(false, application, false);
	}

	let appRes = await GetRecord(APIS.Antrag, appId, { customPopulate: get(application, P.Allgemein_Antragsformular.path, '') });
	const applicationFromRes = removeNullDeep(removeDataKeys(get(appRes, 'data', [])));
	let res = transformValues(appRes, enumT);

	const allKostenpositionen = get(applicationFromRes, P.Foerderantrag_Kostenpositions.path, []);
	const antragstellerAnzeigeName = 'Antragsteller/in';
	const verbundpartnerByOrgId = new Map<number, string>();
	const allVerbundpartner = get(applicationFromRes, P.Verbundpartner.path, []);

	allVerbundpartner.forEach((eachPartner: any, index: number) => {
		const partnerOrgId = get(eachPartner, `${ANTRAG_VERBUNDPARTNER.Partner}.id`, null);
		const partnerAnzeigeNameForVerbundpartner = getVPAnzeigeName(eachPartner) || get(eachPartner, ANTRAG_VERBUNDPARTNER.Name, '');
		set(res, `data.${P.Verbundpartner.path}.${index}.AnzeigeName`, partnerAnzeigeNameForVerbundpartner);

		if (!partnerOrgId) return;

		const partnerAnzeigeNameForKostenposition = getVerbundPartnerName(eachPartner, index) || get(eachPartner, ANTRAG_VERBUNDPARTNER.Name, '');
		verbundpartnerByOrgId.set(partnerOrgId, partnerAnzeigeNameForKostenposition);
	});
	//Save Kürzel for Verbundpartner in each kostenposition
	allKostenpositionen.forEach((eachKostenposition: any, index: number) => {
		const kostentraeger = get(eachKostenposition, KP_P.Allgemein_Kostentraeger.path, '');
		const unternehmenId = get(eachKostenposition, KP_P.Unternehmen.path + '.id', null);
		let anzeigeName = '';

		if (kostentraeger === KOSTENTRAEGER.Verbundpartner) {
			anzeigeName = unternehmenId ? (verbundpartnerByOrgId.get(unternehmenId) ?? '') : '';
		} else {
			anzeigeName = antragstellerAnzeigeName;
		}

		if (!anzeigeName) {
			const unternehmenKuerzel = get(eachKostenposition, KP_P.Unternehmen.schema.attributes.Geschaeftsbezogene_Daten_Kuerzel.path, '');
			const unternehmenName = get(eachKostenposition, KP_P.Unternehmen.schema.attributes.Geschaeftsbezogene_Daten_Name_Der_Organisation.path, '');
			anzeigeName = unternehmenKuerzel || unternehmenName || '';
		}

		set(res, `data.${P.Foerderantrag_Kostenpositions.path}.data.${index}.attributes.AnzeigeName`, anzeigeName);
	});

	// Fetch all images and wait for all promises to resolve
	for (let item of ImagesPaths) {
		let eachImageARR = get(applicationFromRes, item, []);
		for (let eachImageField of eachImageARR) {
			let imageID = get(eachImageField, 'Bild.id');
			let imageExt = get(eachImageField, 'Bild.attributes.ext');
			let imageURL = get(eachImageField, 'Bild.attributes.url');
			if (imageURL) {
				const fileUrl = imageURL.startsWith('/private/') ? `${STRAPI_URL}/api/files${imageURL}` : `${STRAPI_URL}${imageURL}`;
				let downloadImageRes = await fetch(fileUrl, {
					credentials: 'include',
				});
				const blob = await downloadImageRes.blob();
				images.push({ id: imageID, ext: imageExt, imageFile: blob });
			}
		}
	}

	// Convert the response object to a JSON string
	let jsonString = JSON.stringify(res);

	// Create a Blob from the JSON string
	let jsonBlob = new Blob([jsonString], { type: 'application/json' });

	let GetAppPDFData = new FormData();
	GetAppPDFData.append('data', jsonBlob, 'antrag_template_daten.json');

	// Append each image to the FormData object with a unique key
	images.forEach((image) => {
		GetAppPDFData.append(`images`, image.imageFile, `${image.id}${image.ext}`);
	});

	let pdfRes = await fetch(templateURL, {
		method: METHOD_POST,
		headers: {
			Authorization: 'Basic ' + btoa(TEMPLATES_SERVICE_PASSWORD),
			'X-Server-Id': TEMPLATES_SERVICE_SERVER_ID,
			'X-Client-Id': TEMPLATES_SERVICE_CLIENT_ID,
		},
		body: GetAppPDFData,
	});
	const isFormantrag = get(applicationFromRes, P.Allgemein_Art_Des_Antrags.path) === ART_DES_ANTRAGS.Formantrag;
	const fileName =
		isFormantrag ? enumT(get(applicationFromRes, P.Allgemein_Art_Des_Antrags.path)) : enumT(get(applicationFromRes, P.Allgemein_Typ.path));
	if (pdfRes) {
		const blob = await pdfRes.blob();
		const objectUrl = URL.createObjectURL(blob);

		const link = document.createElement('a');
		link.href = objectUrl;
		link.download = `${fileName}_${get(applicationFromRes, P.Allgemein_Kurzwort.path, '')}.pdf`;
		document.body.appendChild(link);
		link.click();
		link.remove();
		URL.revokeObjectURL(objectUrl);
	}
};

const getMittelabrufNumber = (mittelabruf: any, maID: number) => {
	const projektJahr = get(mittelabruf, MA_P.Allgemein_Haushaltsjahr.path);
	const mittelabrufe = get(mittelabruf, MA_P.Foerderantrag.schema.attributes.Foerderantrag_Mittelabrufs.path, []);
	const mittelabrufeImProjektJahr = getMittelabrufeFromProjektJahr(mittelabrufe, projektJahr);
	const index = mittelabrufeImProjektJahr.findIndex((eachMA: any) => get(eachMA, 'id') === maID);

	return index >= 0 ? index + 1 : 0;
};
export const DownloadMittelabrufPDF = async (
	mittelabruf: any,
	readOnly: boolean,
	saveApplication: (submit: boolean, app: any, changeLastEdited: boolean) => void,
) => {
	const maID = get(mittelabruf, 'id');
	const mittelabrufNumber = getMittelabrufNumber(mittelabruf, maID);
	const templateURL =
		TEMPLATES_URL + get(TEMPLATES_MA, get(mittelabruf, MA_P.Foerderantrag.schema.attributes.Allgemein_Antragsformular.path), TEMPLATES_MA.default);

	if (!readOnly) {
		await saveApplication(false, mittelabruf, false);
	}

	let maRes = await GetRecord(APIS.Mittelabruf, maID, POP_LEVEL.mittelabruf.FULL);
	const maFromRes = removeNullDeep(removeDataKeys(get(maRes, 'data', [])));
	let res = transformValues(maRes, enumT);

	// Convert the response object to a JSON string
	let jsonString = JSON.stringify(res);

	// Create a Blob from the JSON string
	let jsonBlob = new Blob([jsonString], { type: 'application/json' });

	let GetAppPDFData = new FormData();
	GetAppPDFData.append('data', jsonBlob, 'antrag_template_daten.json');

	let pdfRes = await fetch(templateURL, {
		method: METHOD_POST,
		headers: {
			Authorization: 'Basic ' + btoa(TEMPLATES_SERVICE_PASSWORD),
			'X-Server-Id': TEMPLATES_SERVICE_SERVER_ID,
			'X-Client-Id': TEMPLATES_SERVICE_CLIENT_ID,
		},
		body: GetAppPDFData,
	});

	if (pdfRes) {
		const blob = await pdfRes.blob();
		const objectUrl = URL.createObjectURL(blob);
		const mittelabrufNumberSuffix = mittelabrufNumber >= 1 ? `_${mittelabrufNumber}` : '';

		const link = document.createElement('a');
		link.href = objectUrl;
		link.download = `Mittelabruf${mittelabrufNumberSuffix}_${get(maFromRes, MA_P.Foerderantrag.schema.attributes.Allgemein_Kurzwort.path, '')}.pdf`;
		document.body.appendChild(link);
		link.click();
		link.remove();
		URL.revokeObjectURL(objectUrl);
	}
};

export const DownloadVerwendungsnacheisPDF = async (
	verwendungsnachweis: any, // Diese Object ist eigentlich gerade MittelAbruf, weil VN wird zusammen in MA geführt
	readOnly: boolean,
	saveApplication: (submit: boolean, app: any, changeLastEdited: boolean) => void,
) => {
	const ImagesPaths = [VN_P.Nachweis_Der_Beklebung.path];
	const vnID = get(verwendungsnachweis, `id`);
	const templateURL =
		TEMPLATES_URL +
		get(TEMPLATES_VN, get(verwendungsnachweis, MA_P.Foerderantrag.schema.attributes.Allgemein_Antragsformular.path, ''), TEMPLATES_VN.default);
	let images = [];

	if (!readOnly) {
		saveApplication(false, verwendungsnachweis, false);
	}

	let vnRes = await GetRecord(APIS.Verwendungsnachweis, vnID, POP_LEVEL.verwendungsnachweis.FULL);
	const vnFromRes = removeNullDeep(removeDataKeys(get(vnRes, 'data', [])));
	let res = transformValues(vnRes, enumT);

	// Fetch all images and wait for all promises to resolve
	for (let item of ImagesPaths) {
		let eachImageARR = get(vnFromRes, item, []);
		for (let eachImageField of eachImageARR) {
			let imageID = get(eachImageField, 'Datei.id');
			let imageExt = get(eachImageField, 'Datei.attributes.ext');
			let imageURL = get(eachImageField, 'Datei.attributes.url');
			if (imageURL) {
				const fileUrl = imageURL.startsWith('/private/') ? `${STRAPI_URL}/api/files${imageURL}` : `${STRAPI_URL}${imageURL}`;
				let downloadImageRes = await fetch(fileUrl, {
					credentials: 'include',
				});
				const blob = await downloadImageRes.blob();
				images.push({ id: imageID, ext: imageExt, imageFile: blob });
			}
		}
	}

	// Convert the response object to a JSON string
	let jsonString = JSON.stringify(res);

	// Create a Blob from the JSON string
	let jsonBlob = new Blob([jsonString], { type: 'application/json' });

	let GetAppPDFData = new FormData();
	GetAppPDFData.append('data', jsonBlob, 'antrag_template_daten.json');

	// Append each image to the FormData object with a unique key
	images.forEach((image) => {
		GetAppPDFData.append(`images`, image.imageFile, `${image.id}${image.ext}`);
	});

	let pdfRes = await fetch(templateURL, {
		method: METHOD_POST,
		headers: {
			Authorization: 'Basic ' + btoa(TEMPLATES_SERVICE_PASSWORD),
			'X-Server-Id': TEMPLATES_SERVICE_SERVER_ID,
			'X-Client-Id': TEMPLATES_SERVICE_CLIENT_ID,
		},
		body: GetAppPDFData,
	});

	if (pdfRes) {
		const blob = await pdfRes.blob();
		const objectUrl = URL.createObjectURL(blob);

		const link = document.createElement('a');
		link.href = objectUrl;
		link.download = `Verwendungsnachweis_${get(vnFromRes, VN_P.Foerderantrag.schema.attributes.Allgemein_Kurzwort.path, '')}.pdf`;
		document.body.appendChild(link);
		link.click();
		link.remove();
		URL.revokeObjectURL(objectUrl);
	}
};

export const DownloadMittelabrufUndVerwendungsnachweisPDF = async (
	verwendungsnachweis: any,
	readOnly: boolean,
	saveApplication: (submit: boolean, app: any, changeLastEdited: boolean) => void,
) => {
	const VNID = get(verwendungsnachweis, `id`);
	const antragsFormular = get(verwendungsnachweis, MA_P.Foerderantrag.schema.attributes.Allgemein_Antragsformular.path, '');
	const templateURL = TEMPLATES_URL + get(TEMPLATES_MA, antragsFormular, TEMPLATES_MA.default);

	if (!readOnly) {
		saveApplication(false, verwendungsnachweis, false);
	}

	let vnRes = await GetRecord(APIS.Verwendungsnachweis, VNID, POP_LEVEL.verwendungsnachweis.FULL);
	const vnFromRes = removeNullDeep(removeDataKeys(get(vnRes, 'data', [])));
	let res = transformValues(vnRes, enumT);

	// Convert the response object to a JSON string
	let jsonString = JSON.stringify(res);

	// Create a Blob from the JSON string
	let jsonBlob = new Blob([jsonString], { type: 'application/json' });

	let GetAppPDFData = new FormData();
	GetAppPDFData.append('data', jsonBlob, 'antrag_template_daten.json');

	let pdfRes = await fetch(templateURL, {
		method: METHOD_POST,
		headers: {
			Authorization: 'Basic ' + btoa(TEMPLATES_SERVICE_PASSWORD),
			'X-Server-Id': TEMPLATES_SERVICE_SERVER_ID,
			'X-Client-Id': TEMPLATES_SERVICE_CLIENT_ID,
		},
		body: GetAppPDFData,
	});

	if (pdfRes) {
		const blob = await pdfRes.blob();
		const objectUrl = URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.href = objectUrl;
		link.download = `Mittelabruf_${get(vnFromRes, VN_P.Foerderantrag.schema.attributes.Allgemein_Kurzwort.path, '')}.pdf`;
		document.body.appendChild(link);
		link.click();
		link.remove();
		URL.revokeObjectURL(objectUrl);
	}
};

export const DownloadZwischenBerichtPDF = async (
	zwischenBericht: any,
	readOnly: boolean,
	saveApplication: (submit: boolean, app: any, changeLastEdited: boolean) => void,
) => {
	// autofold/fold_next

	const znID = get(zwischenBericht, 'id');
	const templateURL =
		TEMPLATES_URL +
		get(TEMPLATES_ZN, get(zwischenBericht, ZN_P.Foerderantrag.schema.attributes.Allgemein_Antragsformular.path, ''), TEMPLATES_ZN.default);

	if (!readOnly) {
		await saveApplication(false, zwischenBericht, false);
	}

	let znRes = await GetRecord(APIS.Zwischenbericht, znID, POP_LEVEL.zwischenbericht.FULL);
	const znFromRes = removeNullDeep(removeDataKeys(get(znRes, 'data', [])));
	let res = transformValues(znRes, enumT);

	// Convert the response object to a JSON string
	let jsonString = JSON.stringify(res);

	// Create a Blob from the JSON string
	let jsonBlob = new Blob([jsonString], { type: 'application/json' });

	let GetAppPDFData = new FormData();
	GetAppPDFData.append('data', jsonBlob, 'antrag_template_daten.json');

	let pdfRes = await fetch(templateURL, {
		method: METHOD_POST,
		headers: {
			Authorization: 'Basic ' + btoa(TEMPLATES_SERVICE_PASSWORD),
			'X-Server-Id': TEMPLATES_SERVICE_SERVER_ID,
			'X-Client-Id': TEMPLATES_SERVICE_CLIENT_ID,
		},
		body: GetAppPDFData,
	});

	if (pdfRes) {
		const blob = await pdfRes.blob();
		const objectUrl = URL.createObjectURL(blob);

		const link = document.createElement('a');
		link.href = objectUrl;
		link.download = `Zwischenbericht_${get(znFromRes, ZN_P.Foerderantrag.schema.attributes.Allgemein_Kurzwort.path, '')}.pdf`;
		document.body.appendChild(link);
		link.click();
		link.remove();
		URL.revokeObjectURL(objectUrl);
	}
};

export const DownloadAbschlussBerichtPDF = async (
	abschlussBericht: any,
	readOnly: boolean,
	saveApplication: (submit: boolean, app: any, changeLastEdited: boolean) => void,
) => {
	// autofold/fold_next

	const abID = get(abschlussBericht, 'id');
	const templateURL =
		TEMPLATES_URL + get(TEMPLATES_AB, get(abschlussBericht, AB_P.Foerderantrag.schema.attributes.Allgemein_Antragsformular.path, ''));

	if (!readOnly) {
		await saveApplication(false, abschlussBericht, false);
	}

	let abRes = await GetRecord(APIS.Abschlussbericht, abID, POP_LEVEL.abschlussbericht.FULL);
	const abFromRes = removeNullDeep(removeDataKeys(get(abRes, 'data', [])));
	let res = transformValues(abRes, enumT);

	// Convert the response object to a JSON string
	let jsonString = JSON.stringify(res);

	// Create a Blob from the JSON string
	let jsonBlob = new Blob([jsonString], { type: 'application/json' });

	let GetAppPDFData = new FormData();
	GetAppPDFData.append('data', jsonBlob, 'antrag_template_daten.json');

	let pdfRes = await fetch(templateURL, {
		method: METHOD_POST,
		headers: {
			Authorization: 'Basic ' + btoa(TEMPLATES_SERVICE_PASSWORD),
			'X-Server-Id': TEMPLATES_SERVICE_SERVER_ID,
			'X-Client-Id': TEMPLATES_SERVICE_CLIENT_ID,
		},
		body: GetAppPDFData,
	});

	if (pdfRes) {
		const blob = await pdfRes.blob();
		const objectUrl = URL.createObjectURL(blob);

		const link = document.createElement('a');
		link.href = objectUrl;
		link.download = `Abschlussbericht_${get(abFromRes, AB_P.Foerderantrag.schema.attributes.Allgemein_Kurzwort.path, '')}.pdf`;
		document.body.appendChild(link);
		link.click();
		link.remove();
		URL.revokeObjectURL(objectUrl);
	}
};

export const DownloadStammdatenBlatt = async (
	application: any,
	readOnly: boolean,
	saveApplication: (submit: boolean, app: any, changeLastEdited: boolean) => void,
) => {
	const appId = get(application, 'id');
	const templateURL =
		TEMPLATES_URL + get(TEMPLATES_STAMMDATENBLATT, get(application, P.Allgemein_Antragsformular.path), TEMPLATES_STAMMDATENBLATT.default);

	if (!readOnly) {
		await saveApplication(false, application, false);
	}
	let appRes = await GetRecord(APIS.Antrag, appId, { customPopulate: get(application, P.Allgemein_Antragsformular.path, '') });
	let res = transformValues(appRes, enumT);

	// Convert the response object to a JSON string
	let jsonString = JSON.stringify(res);

	// Create a Blob from the JSON string
	let jsonBlob = new Blob([jsonString], { type: 'application/json' });

	let GetAppPDFData = new FormData();
	GetAppPDFData.append('data', jsonBlob, 'antrag_template_daten.json');

	let pdfRes = await fetch(templateURL, {
		method: METHOD_POST,
		headers: {
			Authorization: 'Basic ' + btoa(TEMPLATES_SERVICE_PASSWORD),
			'X-Server-Id': TEMPLATES_SERVICE_SERVER_ID,
			'X-Client-Id': TEMPLATES_SERVICE_CLIENT_ID,
		},
		body: GetAppPDFData,
	});

	if (pdfRes) {
		const blob = await pdfRes.blob();
		const objectUrl = URL.createObjectURL(blob);

		const link = document.createElement('a');
		link.href = objectUrl;
		link.download = `${getAntragstellerName(application) ? getAntragstellerName(application) + '_' : ''}Stammdatenblatt.pdf`;
		document.body.appendChild(link);
		link.click();
		link.remove();
		URL.revokeObjectURL(objectUrl);
	}
};
export const DownloadStammdatenBlattForMA = async (
	mittelabruf: any,
	readOnly: boolean,
	saveApplication: (submit: boolean, app: any, changeLastEdited: boolean) => void,
) => {
	const antrag = get(mittelabruf, MA_P.Foerderantrag.path);
	const appId = get(antrag, 'id');
	const templateURL =
		TEMPLATES_URL + get(TEMPLATES_STAMMDATENBLATT, get(antrag, P.Allgemein_Antragsformular.path), TEMPLATES_STAMMDATENBLATT.default);

	if (!readOnly) {
		await saveApplication(false, mittelabruf, false);
	}
	let appRes = await GetRecord(APIS.Antrag, appId, { customPopulate: get(antrag, P.Allgemein_Antragsformular.path, '') });
	let res = transformValues(appRes, enumT);
	console.log('res before setting MA bank details', res);
	// Use selected Mittelabruf bank details in the generated Antrag Stammdatenblatt.
	set(
		res,
		'data.' + P.Antragstellende_Organisation_Bankverbindung_Bezeichnung.path,
		get(mittelabruf, MA_P.Bankverbindung_Bezeichnung_Des_Kontos.path),
	);
	set(res, 'data.' + P.Antragstellende_Organisation_Bankverbindung_Kontoinhaber.path, get(mittelabruf, MA_P.Bankverbindung_Kontoinhaber.path));
	set(res, 'data.' + P.Antragstellende_Organisation_Bankverbindung_Geldinstitut.path, get(mittelabruf, MA_P.Bankverbindung_Geldinstitut.path));
	set(res, 'data.' + P.Antragstellende_Organisation_Bankverbindung_IBAN.path, get(mittelabruf, MA_P.Bankverbindung_IBAN.path));
	set(res, 'data.' + P.Antragstellende_Organisation_Bankverbindung_BIC.path, get(mittelabruf, MA_P.Bankverbindung_BIC.path));
	console.log('res with MA bank details', res);
	// Convert the response object to a JSON string
	let jsonString = JSON.stringify(res);

	// Create a Blob from the JSON string
	let jsonBlob = new Blob([jsonString], { type: 'application/json' });

	let GetAppPDFData = new FormData();
	GetAppPDFData.append('data', jsonBlob, 'antrag_template_daten.json');

	let pdfRes = await fetch(templateURL, {
		method: METHOD_POST,
		headers: {
			Authorization: 'Basic ' + btoa(TEMPLATES_SERVICE_PASSWORD),
			'X-Server-Id': TEMPLATES_SERVICE_SERVER_ID,
			'X-Client-Id': TEMPLATES_SERVICE_CLIENT_ID,
		},
		body: GetAppPDFData,
	});

	if (pdfRes) {
		const blob = await pdfRes.blob();
		const objectUrl = URL.createObjectURL(blob);

		const link = document.createElement('a');
		link.href = objectUrl;
		link.download = `${getAntragstellerName(antrag) ? getAntragstellerName(antrag) + '_' : ''}Stammdatenblatt.pdf`;
		document.body.appendChild(link);
		link.click();
		link.remove();
		URL.revokeObjectURL(objectUrl);
	}
};

export const DownloadDeMinimis = async (
	application: any,
	readOnly: boolean,
	saveApplication: (submit: boolean, app: any, changeLastEdited: boolean) => void,
) => {
	const appId = get(application, 'id');
	const templateURL = TEMPLATES_URL + get(TEMPLATES_DEMINIMIS, get(application, P.Allgemein_Antragsformular.path), TEMPLATES_DEMINIMIS.default);

	if (!readOnly) {
		await saveApplication(false, application, false);
	}
	let appRes = await GetRecord(APIS.Antrag, appId, { customPopulate: get(application, P.Allgemein_Antragsformular.path, '') });
	let res = transformValues(appRes, enumT);

	// Convert the response object to a JSON string
	let jsonString = JSON.stringify(res);

	// Create a Blob from the JSON string
	let jsonBlob = new Blob([jsonString], { type: 'application/json' });

	let GetAppPDFData = new FormData();
	GetAppPDFData.append('data', jsonBlob, 'antrag_template_daten.json');

	let pdfRes = await fetch(templateURL, {
		method: METHOD_POST,
		headers: {
			Authorization: 'Basic ' + btoa(TEMPLATES_SERVICE_PASSWORD),
			'X-Server-Id': TEMPLATES_SERVICE_SERVER_ID,
			'X-Client-Id': TEMPLATES_SERVICE_CLIENT_ID,
		},
		body: GetAppPDFData,
	});

	const NameDerAntragsteller = getAntragstellerName(application);

	if (pdfRes) {
		const blob = await pdfRes.blob();
		const objectUrl = URL.createObjectURL(blob);

		const link = document.createElement('a');
		link.href = objectUrl;
		link.download = `${NameDerAntragsteller ? NameDerAntragsteller + '_' : ''}De-minimis-Erklaerung.pdf`;
		document.body.appendChild(link);
		link.click();
		link.remove();
		URL.revokeObjectURL(objectUrl);
	}
};

export const DownloadGenehmigung = async (
	application: any,
	readOnly: boolean,
	saveApplication: (submit: boolean, app: any, changeLastEdited: boolean) => void,
) => {
	const appId = get(application, 'id');
	const templateURL = TEMPLATES_URL + get(TEMPLATES_GENEHMIGUNG, get(application, P.Allgemein_Antragsformular.path), TEMPLATES_GENEHMIGUNG.default);

	if (!readOnly) {
		await saveApplication(false, application, false);
	}
	let appRes = await GetRecord(APIS.Antrag, appId, { customPopulate: get(application, P.Allgemein_Antragsformular.path, '') });
	let res = transformValues(appRes, enumT);

	// Convert the response object to a JSON string
	let jsonString = JSON.stringify(res);

	// Create a Blob from the JSON string
	let jsonBlob = new Blob([jsonString], { type: 'application/json' });

	let GetAppPDFData = new FormData();
	GetAppPDFData.append('data', jsonBlob, 'antrag_template_daten.json');

	let pdfRes = await fetch(templateURL, {
		method: METHOD_POST,
		headers: {
			Authorization: 'Basic ' + btoa(TEMPLATES_SERVICE_PASSWORD),
			'X-Server-Id': TEMPLATES_SERVICE_SERVER_ID,
			'X-Client-Id': TEMPLATES_SERVICE_CLIENT_ID,
		},
		body: GetAppPDFData,
	});

	if (pdfRes) {
		const blob = await pdfRes.blob();
		const objectUrl = URL.createObjectURL(blob);

		const link = document.createElement('a');
		link.href = objectUrl;
		link.download = `${get(application, P.Allgemein_Kurzwort.path) ? get(application, P.Allgemein_Kurzwort.path) + '_' : ''}De-Minimis-Erklaerung.pdf`;
		document.body.appendChild(link);
		link.click();
		link.remove();
		URL.revokeObjectURL(objectUrl);
	}
};

export const DownloadSelbstErklaerung = async (
	application: any,
	unternehmenId: number,
	unternehmenName: string,
	positionId: string | undefined,
	readOnly: boolean,
	saveApplication: (submit: boolean, app: any, changeLastEdited: boolean) => void,
) => {
	const appId = get(application, 'id');
	const templateURL =
		TEMPLATES_URL + get(TEMPLATES_SELBST_ERKLAERUNG, get(application, P.Allgemein_Antragsformular.path), TEMPLATES_SELBST_ERKLAERUNG.default);

	if (!readOnly) {
		await saveApplication(false, application, false);
	}

	let appRes = await GetRecord(APIS.Antrag, appId, [
		'Verbundpartner',
		'Verbundpartner.Verbundpartner',
		'Selbsterklaerung_KMU',
		'Selbsterklaerung_KMU.Kmu_Unternehmen',
		'Selbsterklaerung_KMU.Kmu_Kennzahlen',
	]);
	let appResModified = removeDataKeys(removeNullDeep(appRes));
	let res = transformValues(appResModified, enumT);

	let unternehmensDaten: any = {};

	if (positionId) {
		// If position ID dann muss Verbundpartner daten gesendet werden
		const selectedPartner_Obj = get(res, P.Verbundpartner.path, []).find(
			(ele: any) =>
				get(ele, `${ANTRAG_VERBUNDPARTNER.Partner}.id`, -1) === unternehmenId || get(ele, ANTRAG_VERBUNDPARTNER.PositionID, -1) === positionId,
		);
		unternehmensDaten = {
			// DownloadDateiName depends on whether the partner is hochschule or not, if it's hochschule then we show onyl the value from field "Kürzel", otherwise just the name of the partner
			DownloadDateiName: unternehmenName,
			Rechtsverbindlicher_Name_Der_Organisation: get(selectedPartner_Obj, ANTRAG_VERBUNDPARTNER.Name),
			Verbundpartner_Institutionstyp: get(selectedPartner_Obj, ANTRAG_VERBUNDPARTNER.InstitutionTyp),
			Verbundpartner_Strasse_Und_Hausnummer: get(selectedPartner_Obj, ANTRAG_VERBUNDPARTNER.StrasseUndHausnummer),
			Verbundpartner_PLZ: get(selectedPartner_Obj, ANTRAG_VERBUNDPARTNER.PLZ),
			Verbundpartner_Ort: get(selectedPartner_Obj, ANTRAG_VERBUNDPARTNER.Ort),
			Verbundpartner_Telefonnummer: get(selectedPartner_Obj, ANTRAG_VERBUNDPARTNER.Telefon),
			Verbundpartner_E_Mail_Adresse: get(selectedPartner_Obj, ANTRAG_VERBUNDPARTNER.Email),
			Gruendungsdatum: get(selectedPartner_Obj, ANTRAG_VERBUNDPARTNER.GrundungsDatum),
			Handelsregisternummer: get(selectedPartner_Obj, ANTRAG_VERBUNDPARTNER.HandelRegisterNummer),
			Abweichender_Sitz: get(selectedPartner_Obj, ANTRAG_VERBUNDPARTNER.AbweichendSitz),
			Abweichender_Sitz_Strasse_Und_Hausnummer: get(selectedPartner_Obj, ANTRAG_VERBUNDPARTNER.AbweichendStasse),
			Abweichender_Sitz_PLZ: get(selectedPartner_Obj, ANTRAG_VERBUNDPARTNER.AbweichendPLZ),
			Abweichender_Sitz_Ort: get(selectedPartner_Obj, ANTRAG_VERBUNDPARTNER.AbweichendOrt),
			Unternehmensprofil_Name_Des_Geschaeftsfuehrers: get(selectedPartner_Obj, ANTRAG_VERBUNDPARTNER.NameGeschaeftsfuehrer),
		};
	} else {
		// Ansonten Antragsteller Daten
		unternehmensDaten = {
			// DownloadDateiName is the same as Rechtsverbindlicher_Name_Der_Organisation for main applicant, but for partner its different, so we need to set it separately
			DownloadDateiName: unternehmenName,
			Rechtsverbindlicher_Name_Der_Organisation: get(res, P.Antragstellende_Organisa_0074063902_licher_Name_Der_Organisation.path),
			Verbundpartner_Institutionstyp: get(res, P.Antragstellende_Organisation_Institutionstyp_Des_Antragstellers.path),
			Verbundpartner_Strasse_Und_Hausnummer: get(res, P.Antragstellende_Organisation_Strasse_Und_Hausnummer.path),
			Verbundpartner_PLZ: get(res, P.Antragstellende_Organisation_PLZ.path),
			Verbundpartner_Ort: get(res, P.Antragstellende_Organisation_Ort.path),
			Verbundpartner_Telefonnummer: get(res, P.Antragstellende_Organisation_Telefonnummer.path),
			Verbundpartner_E_Mail_Adresse: get(res, P.Antragstellende_Organisation_E_Mail_Adresse.path),
			Gruendungsdatum: get(res, P.Antragstellende_Organisation_Gruendungsdatum.path),
			Handelsregisternummer: get(res, P.Antragstellende_Organisation_Handelsregisternummer.path),
			Abweichender_Sitz: get(res, P.Antragstellende_Organisation_Abweichender_Sitz.path),
			Abweichender_Sitz_Strasse_Und_Hausnummer: get(res, P.Antragstellende_Organisa_0234235106_resse_Strasse_Und_Hausnummer.path),
			Abweichender_Sitz_PLZ: get(res, P.Antragstellende_Organisation_Abweichender_Sitz_Adresse_PLZ.path),
			Abweichender_Sitz_Ort: get(res, P.Antragstellende_Organisation_Abweichender_Sitz_Adresse_Ort.path),
			Unternehmensprofil_Name_Des_Geschaeftsfuehrers: get(res, P.Antragstellende_Organisation_Name_Des_Geschaeftsfuehrers.path),
		};
	}

	const filteredRes = {
		data: {
			attributes: {
				Allgemein_Projekttitel: get(res, P.Allgemein_Projekttitel.path, ''),
				Selbsterklaerung_KMU: get(res, P.Selbsterklaerung_KMU.path, []).filter(
					(ele: any) => get(ele, `${KMU_PATHS.Unternehmen}.id`, -1) === unternehmenId || get(ele, KMU_PATHS.PositionID, '') === positionId,
				),
				Unternehmen: [unternehmensDaten],
				Foerderprogramm: get(res, P.Foerderprogramm.path, []),
			},
		},
	};

	// Convert the response object to a JSON string
	let jsonString = JSON.stringify(filteredRes);

	// Create a Blob from the JSON string
	let jsonBlob = new Blob([jsonString], { type: 'application/json' });

	let GetAppPDFData = new FormData();
	GetAppPDFData.append('data', jsonBlob, 'antrag_template_daten.json');

	let pdfRes = await fetch(templateURL, {
		method: METHOD_POST,
		headers: {
			Authorization: 'Basic ' + btoa(TEMPLATES_SERVICE_PASSWORD),
			'X-Server-Id': TEMPLATES_SERVICE_SERVER_ID,
			'X-Client-Id': TEMPLATES_SERVICE_CLIENT_ID,
		},
		body: GetAppPDFData,
	});

	if (pdfRes) {
		const blob = await pdfRes.blob();
		const objectUrl = URL.createObjectURL(blob);

		const link = document.createElement('a');
		link.href = objectUrl;
		link.download = `KMU-Selbsterklärung${unternehmenName ? '_' + unternehmenName : ''}.pdf`;
		document.body.appendChild(link);
		link.click();
		link.remove();
		URL.revokeObjectURL(objectUrl);
	}
};

export const DownloadRusErklaerung = async (
	application: any,
	unternehmenId: number,
	unternehmenName: string,
	positionId: string | undefined,
	readOnly: boolean,
	saveApplication: (submit: boolean, app: any, changeLastEdited: boolean) => void,
) => {
	const appId = get(application, 'id');
	const templateURL =
		TEMPLATES_URL +
		get(TEMPLATES_SELBST_ERKLAERUNG_RUS, get(application, P.Allgemein_Antragsformular.path), TEMPLATES_SELBST_ERKLAERUNG_RUS.default);

	if (!readOnly) {
		await saveApplication(false, application, false);
	}

	let appRes = await GetRecord(APIS.Antrag, appId, [
		'Foerderprogramm',
		'Foerderprogramm.Foerderrichtlinie',
		'Hochschule',
		'Verbundpartner',
		'Verbundpartner.Verbundpartner',
		'Verbundpartner.Hochschule',
		'Verbundpartner.Antragsberechtigt_Als',
		'Antragstellende_Organisation',
		'Selbsterklaerung_RUS',
	]);
	let appResModified = removeDataKeys(removeNullDeep(appRes));
	let res = transformValues(appResModified, enumT);

	let unternehmensDaten: any = {};

	if (positionId) {
		// If position ID dann muss Verbundpartner daten gesendet werden
		const selectedPartner_Obj = get(res, P.Verbundpartner.path, []).find(
			(ele: any) =>
				get(ele, `${ANTRAG_VERBUNDPARTNER.Partner}.id`, -1) === unternehmenId || get(ele, ANTRAG_VERBUNDPARTNER.PositionID, -1) === positionId,
		);
		const anzeigeName = getVPAnzeigeName(selectedPartner_Obj);
		unternehmensDaten = {
			Rechtsverbindlicher_Name_Der_Organisation: get(selectedPartner_Obj, ANTRAG_VERBUNDPARTNER.Name),
			// DownloadDateiName depends on whether the partner is hochschule or not, if it's hochschule then we show onyl the value from field "Kürzel", otherwise just the name of the partner
			DownloadDateiName: unternehmenName,
			AnzeigeName: anzeigeName,
			Verbundpartner_Institutionstyp: get(selectedPartner_Obj, ANTRAG_VERBUNDPARTNER.InstitutionTyp),
			Verbundpartner_Strasse_Und_Hausnummer: get(selectedPartner_Obj, ANTRAG_VERBUNDPARTNER.StrasseUndHausnummer),
			Verbundpartner_PLZ: get(selectedPartner_Obj, ANTRAG_VERBUNDPARTNER.PLZ),
			Verbundpartner_Ort: get(selectedPartner_Obj, ANTRAG_VERBUNDPARTNER.Ort),
			Verbundpartner_Telefonnummer: get(selectedPartner_Obj, ANTRAG_VERBUNDPARTNER.Telefon),
			Verbundpartner_E_Mail_Adresse: get(selectedPartner_Obj, ANTRAG_VERBUNDPARTNER.Email),
			Gruendungsdatum: get(selectedPartner_Obj, ANTRAG_VERBUNDPARTNER.GrundungsDatum),
			Handelsregisternummer: get(selectedPartner_Obj, ANTRAG_VERBUNDPARTNER.HandelRegisterNummer),
			Abweichender_Sitz: get(selectedPartner_Obj, ANTRAG_VERBUNDPARTNER.AbweichendSitz),
			Abweichender_Sitz_Strasse_Und_Hausnummer: get(selectedPartner_Obj, ANTRAG_VERBUNDPARTNER.AbweichendStasse),
			Abweichender_Sitz_PLZ: get(selectedPartner_Obj, ANTRAG_VERBUNDPARTNER.AbweichendPLZ),
			Abweichender_Sitz_Ort: get(selectedPartner_Obj, ANTRAG_VERBUNDPARTNER.AbweichendOrt),
			Unternehmensprofil_Name_Des_Geschaeftsfuehrers: '',
		};
	} else {
		// Ansonten Antragsteller Daten
		const anzeigeName = getAntragstellerName(application, true);
		unternehmensDaten = {
			Rechtsverbindlicher_Name_Der_Organisation: get(res, P.Antragstellende_Organisa_0074063902_licher_Name_Der_Organisation.path),
			// DownloadDateiName is the same as Rechtsverbindlicher_Name_Der_Organisation for main applicant, but for partner its different, so we need to set it separately
			DownloadDateiName: unternehmenName,
			AnzeigeName: anzeigeName,
			Verbundpartner_Institutionstyp: get(res, P.Antragstellende_Organisation_Institutionstyp_Des_Antragstellers.path),
			Verbundpartner_Strasse_Und_Hausnummer: get(res, P.Antragstellende_Organisation_Strasse_Und_Hausnummer.path),
			Verbundpartner_PLZ: get(res, P.Antragstellende_Organisation_PLZ.path),
			Verbundpartner_Ort: get(res, P.Antragstellende_Organisation_Ort.path),
			Verbundpartner_Telefonnummer: get(res, P.Antragstellende_Organisation_Telefonnummer.path),
			Verbundpartner_E_Mail_Adresse: get(res, P.Antragstellende_Organisation_E_Mail_Adresse.path),
			Gruendungsdatum: get(res, P.Antragstellende_Organisation_Gruendungsdatum.path),
			Handelsregisternummer: get(res, P.Antragstellende_Organisation_Handelsregisternummer.path),
			Abweichender_Sitz: get(res, P.Antragstellende_Organisation_Abweichender_Sitz.path),
			Abweichender_Sitz_Strasse_Und_Hausnummer: get(res, P.Antragstellende_Organisa_0234235106_resse_Strasse_Und_Hausnummer.path),
			Abweichender_Sitz_PLZ: get(res, P.Antragstellende_Organisation_Abweichender_Sitz_Adresse_PLZ.path),
			Abweichender_Sitz_Ort: get(res, P.Antragstellende_Organisation_Abweichender_Sitz_Adresse_Ort.path),
			Unternehmensprofil_Name_Des_Geschaeftsfuehrers: get(res, P.Antragstellende_Organisation_Name_Des_Geschaeftsfuehrers.path),
		};
	}

	const filteredRes = {
		data: {
			attributes: {
				Allgemein_Projekttitel: get(res, P.Allgemein_Projekttitel.path, ''),
				Selbsterklaerung_RUS: get(res, P.Selbsterklaerung_RUS.path, []).filter(
					(ele: any) => get(ele, `${RUS_PATH.Unternehmen}.id`, -1) === unternehmenId || get(ele, RUS_PATH.PositionID, '') === positionId,
				),
				Unternehmen: [unternehmensDaten],
				Foerderprogramm: get(res, P.Foerderprogramm.path, []),
			},
		},
	};

	// Convert the response object to a JSON string
	let jsonString = JSON.stringify(filteredRes);

	// Create a Blob from the JSON string
	let jsonBlob = new Blob([jsonString], { type: 'application/json' });

	let GetAppPDFData = new FormData();
	GetAppPDFData.append('data', jsonBlob, 'antrag_template_daten.json');

	let pdfRes = await fetch(templateURL, {
		method: METHOD_POST,
		headers: {
			Authorization: 'Basic ' + btoa(TEMPLATES_SERVICE_PASSWORD),
			'X-Server-Id': TEMPLATES_SERVICE_SERVER_ID,
			'X-Client-Id': TEMPLATES_SERVICE_CLIENT_ID,
		},
		body: GetAppPDFData,
	});

	if (pdfRes) {
		const blob = await pdfRes.blob();
		const objectUrl = URL.createObjectURL(blob);

		const link = document.createElement('a');
		link.href = objectUrl;
		link.download = `RUS-Selbsterklärung${unternehmenName ? '_' + unternehmenName : ''}.pdf`;
		document.body.appendChild(link);
		link.click();
		link.remove();
		URL.revokeObjectURL(objectUrl);
	}
};

export const DownloadMitteilungAnderZuwendungsgeber = async (
	application: any,
	readOnly: boolean,
	saveApplication: (submit: boolean, app: any, changeLastEdited: boolean) => void,
	positionId: number,
) => {
	const appId = get(application, 'id');
	const templateURL =
		TEMPLATES_URL +
		get(TEMPLATES_MITTEILUNG_ZUWENDUNGSGEBER, get(application, P.Allgemein_Antragsformular.path), TEMPLATES_MITTEILUNG_ZUWENDUNGSGEBER.default);

	if (!readOnly) {
		await saveApplication(false, application, false);
	}

	let appRes = await GetRecord(APIS.Antrag, appId, { customPopulate: get(application, P.Allgemein_Antragsformular.path, '') });
	let res = transformValues(appRes, enumT);
	const selectedEigenmittel = get(res, `data.${P.Foerderantrag_Kostenpositions.path}.data`, []).filter((ele: any) => get(ele, 'id') === positionId);

	set(res, `data.${P.Foerderantrag_Kostenpositions.path}.data`, selectedEigenmittel);

	// Convert the response object to a JSON string
	let jsonString = JSON.stringify(res);

	// Create a Blob from the JSON string
	let jsonBlob = new Blob([jsonString], { type: 'application/json' });

	let GetAppPDFData = new FormData();
	GetAppPDFData.append('data', jsonBlob, 'antrag_template_daten.json');

	let pdfRes = await fetch(templateURL, {
		method: METHOD_POST,
		headers: {
			Authorization: 'Basic ' + btoa(TEMPLATES_SERVICE_PASSWORD),
			'X-Server-Id': TEMPLATES_SERVICE_SERVER_ID,
			'X-Client-Id': TEMPLATES_SERVICE_CLIENT_ID,
		},
		body: GetAppPDFData,
	});

	if (pdfRes) {
		const blob = await pdfRes.blob();
		const objectUrl = URL.createObjectURL(blob);

		const link = document.createElement('a');
		link.href = objectUrl;
		link.download = `${get(application, P.Allgemein_Kurzwort.path) ? get(application, P.Allgemein_Kurzwort.path) + '_' : ''}Mitteilung_anderer_Zuwendungsgeber.pdf`;
		document.body.appendChild(link);
		link.click();
		link.remove();
		URL.revokeObjectURL(objectUrl);
	}
};
